routing.$inject = ['$urlRouterProvider', '$locationProvider', '$breadcrumbProvider'];
import template from '../views/breadcrumbs/template.html';

export default function routing($urlRouterProvider, $locationProvider, $breadcrumbProvider) {
    $urlRouterProvider.when('', '/');
    $urlRouterProvider.otherwise("/404");
    $locationProvider.hashPrefix('classic');

    $breadcrumbProvider.setOptions({
        template: template
    });
}

